class StearsBaseError extends Error {
  public readonly details?: Record<string, string | string[]>

  constructor(details?: Record<string, string | string[]>) {
    super()
    this.details = details
  }
}

export class NetworkError extends StearsBaseError {}
export class HttpError extends StearsBaseError {
  public readonly statusCode: number

  constructor(details?: Record<string, string | string[]>, statusCode = 400) {
    super(details)
    this.statusCode = statusCode
  }
}
